import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';

import {
  BLOCKED_NOTICE_BODY,
  BLOCKED_NOTICE_HINT,
  BLOCKED_NOTICE_TITLE,
} from './DocumentBlockedNotice.constants';
import { blockedNoticeBodySx, blockedNoticeWrapperSx } from './DocumentBlockedNotice.styles';
import { DocumentBlockedNoticeTestIds } from './DocumentBlockedNotice.testIds';

const DocumentBlockedNotice = () => (
  <Box
    data-testid={DocumentBlockedNoticeTestIds.DOCUMENT_BLOCKED_NOTICE}
    sx={blockedNoticeWrapperSx}
  >
    <Typography color="error.main" variant="medium16">
      {BLOCKED_NOTICE_TITLE}
    </Typography>

    <Typography color="text.secondary" sx={blockedNoticeBodySx} variant="regular14">
      {BLOCKED_NOTICE_BODY}
    </Typography>

    <Typography color="text.secondary" variant="regular12">
      {BLOCKED_NOTICE_HINT}
    </Typography>
  </Box>
);

export default memo(DocumentBlockedNotice);
